import * as RadixPopover from '@radix-ui/react-popover'
import React from 'react'
import styled from 'styled-components'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type InstantTradePopoverProps = {
  content: React.ReactNode
  type: 'wallets' | 'settings'
} & ChildrenProps &
  ClassNameProps

export const InstantTradeBottomPopover: React.FC<InstantTradePopoverProps> = ({
  children,
  content,
  type,
  className,
}) => {
  const alignOffset = type === 'wallets' ? -49 : -11

  return (
    <RadixPopover.Root>
      <RadixPopover.Trigger asChild>{children}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <Content
          side="bottom"
          sideOffset={16}
          alignOffset={alignOffset}
          align="end"
          className={className}
        >
          {content}
        </Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  )
}

const Content = styled(RadixPopover.Content)`
  border-radius: 10px;
  border: 1px solid var(--backgroundA-2);
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(60px);
`
